import type { NavItem } from '@billy/design-system'
import type { TFunction } from 'i18next'

import { InvoiceTotalPriceColumns } from '@features/invoices/enums/invoiceTotalPriceColumns'

export const getTotalPriceColumnsItems = (t: TFunction): NavItem<InvoiceTotalPriceColumns>[] => [
  {
    children: t('external_invoices.editor.form.field.line.header.total_excluding_vat'),
    id: InvoiceTotalPriceColumns.Net,
    value: InvoiceTotalPriceColumns.Net,
  },
  {
    children: t('external_invoices.editor.form.field.line.header.total_including_vat'),
    id: InvoiceTotalPriceColumns.Gross,
    value: InvoiceTotalPriceColumns.Gross,
  },
  {
    children: t(
      'external_invoices.editor.form.field.invoice_lines.column_visibility_settings.columns.total_price.both',
    ),
    id: InvoiceTotalPriceColumns.Both,
    value: InvoiceTotalPriceColumns.Both,
  },
]
